import React from 'react';
import { Field, reduxForm } from 'redux-form';
import styles from './LibraryCOGSModal.css';

const validate = () => {
  const errors = {};
  // have no validation in experiment
  return errors;
};

class LibraryCOGSForm extends React.Component {
  render() {
    const { initDisabledColumn, libraryForm, units } = this.props;
    return (
      <form id="form-library-cogs">
        <table className={`table table-responsive ${styles.table}`}>
          <thead>
            <tr>
              <th>Ingredient</th>
              <th>Track COGS</th>
              <th>Avg Cost</th>
              <th>Unit</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className={`${styles['text-elipsis']}`}>
                <span name="name">{libraryForm && libraryForm.name}</span>
              </td>
              <td>
                <div className="checkbox checkbox-primary checkbox-item checkbox-circle">
                  <Field
                    component="input"
                    name={`track_cogs`}
                    type="checkbox"
                    id={`checkbox-track-cogs`}
                  />
                  <label for={`checkbox-track-cogs`} />
                </div>
              </td>
              <td>
                <div className="form-group">
                  <div className={styles['rp-avgCost']}>Rp</div>
                  <Field
                    component="input"
                    name={`cogs`}
                    type="text"
                    className={`form-control text-right ${
                      styles['input-avgCost']
                    }`}
                    onKeyPress={this._setOnlyNumber}
                    disabled={initDisabledColumn}
                  />
                </div>
              </td>
              <td>
                {libraryForm && libraryForm.unit_id
                  ? `Per ${
                      units.find(
                        unit =>
                          parseInt(unit.id) === parseInt(libraryForm.unit_id)
                      ).name
                    }`
                  : ''}
              </td>
            </tr>
          </tbody>
        </table>
      </form>
    );
  }

  _setOnlyNumber = e => {
    const regex = /[0-9:]+/g;
    if (!regex.test(e.key)) {
      e.preventDefault();
    }
  };
}

export default reduxForm({
  form: 'libraryCOGS',
  touchOnBlur: false,
  touchOnChange: true,
  validate,
})(LibraryCOGSForm);
